exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.btn-add[data-v-62ae24f7] {\n    border-radius: 2px;\n}\n.empty-message[data-v-62ae24f7] {\n    text-align: center;\n}\n.btn-view[data-v-62ae24f7] {\n    border-radius: 3px;\n}\n.badge-group[data-v-62ae24f7] {\n    margin: 0 4px;\n    font-size: 0.85em;\n    background-color: #147738;\n    color: #ffffff;\n}\n", ""]);

// exports
